/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ProgressiveDateIntervalDto = {
    name: ProgressiveDateIntervalDto.name;
    lastTimeShown: string;
    pastIntervals: Array<number>;
    showIntervals: Array<number>;
};

export namespace ProgressiveDateIntervalDto {

    export enum name {
        DAILY_REMINDERS = 'daily-reminders',
    }


}

